import {css} from '../../theme/css'
import {spacing} from '../../theme/theme'

export const icon = css`
  width: ${spacing(5)};
  height: ${spacing(5)};
`
